<template>
  <div class="h-full w-full">
    <header
      :class="[
        'w-full fixed z-10 bg-white',
        isScrolled ? 'shadow-md' : 'shadow-none',
      ]"
    >
      <div
        class="flex justify-between px-6 md:px-24 items-center"
        @click.self="closeMenus"
      >
        <!-- Logo -->
        <a class="text-[28px] md:text-[55px] py-2 left-5" href="/">
          Núria Jordán
        </a>

        <!-- Botón Hamburguesa -->
        <button
          class="md:hidden flex items-center text-lg focus:outline-none"
          @click="toggleMobileMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              :d="
                isMobileMenuOpen
                  ? 'M6 18L18 6M6 6l12 12'
                  : 'M4 6h16M4 12h16M4 18h16'
              "
            />
          </svg>
        </button>

        <!-- Menú principal -->
        <div
          class="hidden md:flex gap-8"
          :class="{ block: !isMobileMenuOpen, hidden: isMobileMenuOpen }"
        >
          <!-- Projectes con submenú en desktop -->
          <div class="relative group">
            <ul>
              <a href="/projects" class="cursor-pointer">
                <li
                  class="text-lg cursor-pointer hover:underline underline-offset-4"
                >
                  Projectes
                </li>
              </a>
            </ul>
            <ul
              class="absolute left-0 transform -translate-x-1/3 bg-white shadow-lg rounded-lg py-2 text-center w-48 z-20 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300"
            >
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/prova"> L'anòmala</a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/modern"> El Modern </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/wildtech"> Wildtech </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/sense"> Sense </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/broomx"> Broomx </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/units"> Units x Educar </a>
              </li>
            </ul>
          </div>

          <!-- Sobre mi -->
          <div class="relative">
            <p
              class="text-lg cursor-pointer hover:underline underline-offset-4"
            >
              <a href="/presentacio"> Sobre mi </a>
            </p>
          </div>
        </div>
        <div
          class="absolute top-full left-0 w-full bg-white shadow-md md:hidden"
          v-show="isMobileMenuOpen"
        >
          <ul class="flex flex-col items-center py-4 space-y-4">
            <li>
              <a href="/projects" class="text-lg">Projectes</a>
            </li>
            <li>
              <a href="/presentacio" class="text-lg">Sobre mi</a>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <div class="pt-[50px] md:px-24 md:pt-[80px] relative">
      <div>
        <ul class="flex gap-4 my-6 overflow-x-scroll md:overflow-hidden">
          <li
            @click="changeInfo('presentacio')"
            :class="[
              info === 'presentacio'
                ? 'text-black underline'
                : 'text-gray-300 hover:text-black',
              'cursor-pointer text-lg',
            ]"
          >
            Presentació
          </li>
          <li
            @click="changeInfo('experiencia')"
            :class="[
              info === 'experiencia'
                ? 'text-black underline'
                : 'text-gray-300 hover:text-black',
              'cursor-pointer text-lg',
            ]"
          >
            Experiència
          </li>
          <li
            @click="changeInfo('habilitats')"
            :class="[
              info === 'habilitats'
                ? 'text-black underline'
                : 'text-gray-300 hover:text-black',
              'cursor-pointer text-lg',
            ]"
          >
            Habilitats
          </li>
          <li
            @click="changeInfo('contacte')"
            :class="[
              info === 'contacte'
                ? 'text-black underline'
                : 'text-gray-300 hover:text-black',
              'cursor-pointer text-lg',
            ]"
          >
            Contacte
          </li>
        </ul>
      </div>
      <div v-if="info === 'presentacio'" class="md:p-32">
        <h1 class="text-2xl font-semibold text-center">Presentació</h1>
        <p class="text-center pt-6 px-8 md:px-16">
          Soc Núria Jordán, estudiant de Comunicació Audiovisual i Multimèdia.
          Tinc 22 anys, i en aquests quatre anys de carrera he après diferents
          habilitats com la programació web, el disseny gràfic, fotografia i
          vídeo, i una mica de 3D. Em considero una persona extrovertida,
          enèrgica i amb habilitats de comunicació efectiva. Tinc experiència
          treballant en equip i col·laborant en projectes per a aconseguir
          objectius de manera eficaç. Estic compromesa a continuar desenvolupant
          les meves habilitats i continuar aprenent.
        </p>
      </div>
      <div v-if="info === 'experiencia'">
        <h1 class="text-2xl font-semibold text-center">Experiència</h1>
        <div class="px-8 md:px-0 pb-12">
          <div class="pt-6 w-full flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">
                  {{ $t("webDeveloper") }} Units x Educar
                </p>
                <p class="text-sm md:text-base">{{ $t("june") }} 2024</p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exUnits") }}
              </p>
            </div>
            <div class="md:pt-6 flex flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">{{ $t("prBroomx") }}</p>
                <p class="text-sm md:text-base">
                  {{ $t("february") }} 2024 - {{ $t("june") }} 2024
                </p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exBroomx") }}
              </p>
            </div>
            <div class="md:pt-6 flex flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">
                  {{ $t("membre") }} Playful Living Lab
                </p>
                <p class="text-sm md:text-base">
                  {{ $t("september") }} 2023 - {{ $t("june") }} 2024
                </p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exLab") }}
              </p>
            </div>
            <div class="md:pt-6 flex flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">
                  {{ $t("coCreator") }} Wildtech
                </p>
                <p class="text-sm md:text-base">
                  {{ $t("september") }} 2023 - {{ $t("june") }} 2024
                </p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exWildtech") }}
              </p>
            </div>
            <div class="md:pt-6 flex flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">
                  {{ $t("coCreator") }} Mural “El Modern”
                </p>
                <p class="text-sm md:text-base">
                  {{ $t("january") }} 2023 - {{ $t("march") }} 2023
                </p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exModern") }}
              </p>
            </div>
            <div class="md:pt-6 flex flex flex-col gap-2">
              <div class="md:flex justify-between">
                <p class="text-sm md:text-base">
                  {{ $t("profesora") }} Workshop Wordpress
                </p>
                <p class="text-sm md:text-base">{{ $t("january") }} 2023</p>
              </div>
              <p class="text-xs md:text-sm text-zinc-500">
                {{ $t("exEram") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="info === 'habilitats'" class="px-12 md:px-0">
        <h1 class="text-2xl font-semibold text-center">Habilitats</h1>
        <div class="flex">
          <div class="pt-4 w-full">
            <div>
              <p class="font-semibold pb-6 text-center">
                {{ $t("lenguagesProgramming") }}
              </p>
              <div class="flex flex-wrap flex-row gap-4 justify-center">
                <div class="text-center flex flex-col items-center">
                  <div class="circle setanta">
                    <span>75%</span>
                  </div>
                  <p>HTML</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle setanta">
                    <span>75%</span>
                  </div>
                  <p>CSS</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle cinc">
                    <span>50%</span>
                  </div>
                  <p>JS</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle cinc">
                    <span>50%</span>
                  </div>
                  <p>Vue.js</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle trenta">
                    <span>35%</span>
                  </div>
                  <p>Svelte.js</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle vint">
                    <span>25%</span>
                  </div>
                  <p>Node.js</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle vint">
                    <span>25%</span>
                  </div>
                  <p>Socket.io</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle sis">
                    <span>65%</span>
                  </div>
                  <p>Boostrap</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle setanta">
                    <span>75%</span>
                  </div>
                  <p>Tailwind</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle cinc">
                    <span>50%</span>
                  </div>
                  <p>GSAP</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle quatre">
                    <span>40%</span>
                  </div>
                  <p>MongoDB</p>
                </div>
                <div class="text-center flex flex-col items-center">
                  <div class="circle sis">
                    <span>65%</span>
                  </div>
                  <p>Wordpress</p>
                </div>
              </div>
            </div>
            <div class="pt-6">
              <p class="font-semibold text-center">Software</p>
              <div
                class="flex flex-wrap justify-center items-center gap-x-6 gap-y-4"
              >
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/Figma.png"
                    alt="Figma"
                    class="w-14 h-14"
                  />
                  <p>Figma</p>
                </div>
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/Adobe_XD_CC_icon.svg.png"
                    alt="Adobe XD"
                    class="w-14 h-14"
                  />
                  <p>XD</p>
                </div>
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/adobe-photoshop-logo-2.png"
                    alt="Photoshop"
                    class="w-14 h-14"
                  />
                  <p>Photoshop</p>
                </div>
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/Adobe_Illustrator_CC_icon.svg.png"
                    alt="Illustrator"
                    class="w-14 h-14"
                  />
                  <p>Illustrator</p>
                </div>
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/Adobe_InDesign_CC_icon.svg.png"
                    alt="InDesign"
                    class="w-14 h-14"
                  />
                  <p>InDesign</p>
                </div>
                <div class="flex flex-col items-center text-center">
                  <img
                    src="../../public/img/Final_Cut_Pro_iPad.webp"
                    alt="Final Cut Pro"
                    class="w-14 h-14"
                  />
                  <p>Final Cut</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="info === 'contacte'" class="px-12 md:p-32">
        <h1 class="text-2xl font-semibold text-center">Contacte</h1>
        <div class="md:px-24 py-4">
          <p class="text-sm md:text-base">
            {{ $t("contactText") }}
            <u>nurianusan@gmail.com</u>
          </p>
          <p class="text-sm md:text-base pt-4">
            {{ $t("tmbContact") }}
            <a
              href="https://www.linkedin.com/in/núria-jordán-sánchez-3b5889120/"
              target="_blank"
              class="underline"
              >linkedin</a
            >
            {{ $t("tmbContact2") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectsVisible: false,
      isVisible: false,
      info: "presentacio",
      isMobileMenuOpen: false,
    };
  },
  methods: {
    toggleProjects() {
      this.projectsVisible = !this.projectsVisible;
      this.isVisible = false;
    },
    toggleInfo() {
      this.isVisible = !this.isVisible;
      this.projectsVisible = false;
    },
    closeMenus() {
      this.projectsVisible = false;
      this.isVisible = false;
    },
    changeInfo(data) {
      this.info = data;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobile() {
      this.isMobileMenuOpen = false;
    },
  },
};
</script>